module.exports = __webpack_public_path__ + "static/media/12.db068e9c.svg";